// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"f88bc417","57":"ad1be719","107":"8b342727","323":"504ed70c","411":"f11d27d3","639":"dc6caf41","652":"9bf82b3a","763":"143fe6a5"}[chunkId] + ".chunk.js";
};